import { IRootState } from '@/store';
import { IQuoteTemplateState } from '@/store/quotetemplate';
import {
  IQuoteServiceTemplateData,
  IQuoteFreightTemplateData,
  IQuotePaymentTermTemplateData,
  IQuoteTermTemplateData
} from '@/models';
import { MutationTree, Store } from 'vuex';

export enum IQuoteTemplateMutationsEnum {
  SET_QUOTE_SERVICE_TEMPLATES = 'SET_QUOTE_SERVICE_TEMPLATES',
  ADD_QUOTE_SERVICE_TEMPLATE = 'ADD_QUOTE_SERVICE_TEMPLATE',
  UPDATE_QUOTE_SERVICE_TEMPLATE = 'UPDATE_QUOTE_SERVICE_TEMPLATE',
  REMOVE_QUOTE_SERVICE_TEMPLATE = 'REMOVE_QUOTE_SERVICE_TEMPLATE',

  //FREIGHTS
  SET_QUOTE_FREIGHT_TEMPLATES = 'SET_QUOTE_FREIGHT_TEMPLATES',
  ADD_QUOTE_FREIGHT_TEMPLATE = 'ADD_QUOTE_FREIGHT_TEMPLATE',
  UPDATE_QUOTE_FREIGHT_TEMPLATE = 'UPDATE_QUOTE_FREIGHT_TEMPLATE',
  REMOVE_QUOTE_FREIGHT_TEMPLATE = 'REMOVE_QUOTE_FREIGHT_TEMPLATE',

  //PAYMENT TERMS
  SET_QUOTE_PAYMENT_TERM_TEMPLATES = 'SET_QUOTE_PAYMENT_TERM_TEMPLATES',
  ADD_QUOTE_PAYMENT_TERM_TEMPLATE = 'ADD_QUOTE_PAYMENT_TERM_TEMPLATE',
  UPDATE_QUOTE_PAYMENT_TERM_TEMPLATE = 'UPDATE_QUOTE_PAYMENT_TERM_TEMPLATE',
  REMOVE_QUOTE_PAYMENT_TERM_TEMPLATE = 'REMOVE_QUOTE_PAYMENT_TERM_TEMPLATE',

  //TERMS
  SET_QUOTE_TERM_TEMPLATES = 'SET_QUOTE_TERM_TEMPLATES',
  SET_QUOTE_TERM_TEMPLATES_ORDER = 'SET_QUOTE_TERM_TEMPLATES_ORDER',
  ADD_QUOTE_TERM_TEMPLATE = 'ADD_QUOTE_TERM_TEMPLATE',
  UPDATE_QUOTE_TERM_TEMPLATE = 'UPDATE_QUOTE_TERM_TEMPLATE',
  REMOVE_QUOTE_TERM_TEMPLATE = 'REMOVE_QUOTE_TERM_TEMPLATE'
}

export interface IQuoteTemplateMutations
  extends MutationTree<IQuoteTemplateState> {
  //SERVICES
  [IQuoteTemplateMutationsEnum.SET_QUOTE_SERVICE_TEMPLATES](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData[]
  ): void;

  [IQuoteTemplateMutationsEnum.ADD_QUOTE_SERVICE_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.UPDATE_QUOTE_SERVICE_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.REMOVE_QUOTE_SERVICE_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: number
  ): void;

  //FREIGHTS
  [IQuoteTemplateMutationsEnum.SET_QUOTE_FREIGHT_TEMPLATES](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData[]
  ): void;

  [IQuoteTemplateMutationsEnum.ADD_QUOTE_FREIGHT_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.UPDATE_QUOTE_FREIGHT_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.REMOVE_QUOTE_FREIGHT_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: number
  ): void;

  //PAYMENT TERMS
  [IQuoteTemplateMutationsEnum.SET_QUOTE_PAYMENT_TERM_TEMPLATES](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData[]
  ): void;

  [IQuoteTemplateMutationsEnum.ADD_QUOTE_PAYMENT_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.UPDATE_QUOTE_PAYMENT_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.REMOVE_QUOTE_PAYMENT_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: number
  ): void;

  //TERMS
  [IQuoteTemplateMutationsEnum.SET_QUOTE_TERM_TEMPLATES](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData[]
  ): void;

  [IQuoteTemplateMutationsEnum.ADD_QUOTE_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.UPDATE_QUOTE_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData
  ): void;

  [IQuoteTemplateMutationsEnum.REMOVE_QUOTE_TERM_TEMPLATE](
    this: Store<IRootState>,
    state: IQuoteTemplateState,
    payload: number
  ): void;
}
